import { useState, useEffect, useRef } from "react";

const experienceData = [
    {
        role: "Mobile & Front-End Developer",
        company: "Proyectos por contrato – Almoby Software Solutions",
        date: "Febrero 2025 – Actualmente",
        projects: [
            {
                name: "Almotick (Ecosistema de Ticketing)",
                subtitle: "React Native, Expo, TypeScript, REST APIs",
                description: "Desarrollo de la plataforma web de venta y su aplicación complementaria de control de acceso. Lideré el desarrollo de la plataforma web y la herramienta de validación para el escaneo de códigos QR en tiempo real (entradas y consumos), optimizada para alta concurrencia en eventos masivos con +50.000 ventas procesadas e integración con MercadoPago."
            },
            {
                name: "AnaVir",
                subtitle: "React, TypeScript, Tailwind CSS, Redux, REST APIs",
                description: "Sistema de gestión de personal y gastos que mejoró el control operativo y la administración interna."
            },
            {
                name: "Toronto Trust",
                subtitle: "React, TypeScript, REST APIs",
                description: "Automatización de reportes y generación de Excel, reduciendo tareas manuales y tiempos operativos."
            }
        ]
    },
    {
        role: "Mobile & Front-End Developer",
        company: "Efectivo – MacroIntell",
        date: "Enero 2024 – Febrero 2026",
        projects: [
            {
                name: "AgroCarteira",
                subtitle: "React Native, Expo, TypeScript, Clean Architecture, Pix, Swift, Kotlin, OCR services",
                description: "Billetera virtual para el mercado brasileño con validaciones CPF/CNPJ mediante OCR usando servicios de terceros e integración de pagos, adaptada con código nativo para requerimientos locales."
            },
            {
                name: "TodoAgro",
                subtitle: "React Native, Expo, TypeScript, REST APIs",
                description: "App mobile con checkout, gestión segura de tarjetas, carrito en tiempo real y reglas de negocio, enfocada en performance y UX."
            },
            {
                name: "Release & CI/CD",
                subtitle: "GitLab CI/CD, Expo EAS, Webhooks",
                description: "Configuración de pipelines de build y deploy y publicación de apps en producción. Notificación de estados de deploys y publicaciones mediante webhooks de canales de discord."
            },
            {
                name: "Liderazgo de equipo",
                subtitle: "Scrum, Trello, Clickup",
                description: "Planificación de sprints, priorización y seguimiento de entregables. Presentación de avances en reuniones demo, siguiendo metodología Scrum."
            },
            {
                name: "Calidad y escalabilidad",
                subtitle: "Refactor, Clean Code",
                description: "Reducción de deuda técnica y mejora de mantenibilidad."
            }
        ]
    }
];

const Experience = () => {
    const [isVisible, setIsVisible] = useState(false);
    const experienceRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );

        if (experienceRef.current) {
            observer.observe(experienceRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div className="ps-5 pe-5 pb-0 m-0 skills-component" id="experience-section" ref={experienceRef}>
                <h3 id="experience" className="text-uppercase title  m-0  p-0  text-center mb-2">Experiencia</h3>
                <div className="row d-flex justify-content-center text-start">
                    {experienceData.map((exp, index) => (
                        <div key={index} className={`col-12 col-xl-10 mb-3 p-4 rounded mx-2 ${isVisible ? 'fade-in' : ''}`} style={{ backgroundColor: "#d8d8d8ff", animationDelay: `${index * 0.4}s`, visibility: isVisible ? 'visible' : 'hidden' }}>
                            <h4 className="fw-bold text-dark fs-3 mb-1">{exp.role}</h4>
                            <h5 className="text-secondary fw-bold fs-5 mb-2">{exp.company}</h5>
                            <p className="text-muted fw-bold mb-4">{exp.date}</p>

                            <ul className="list-unstyled">
                                {exp.projects.map((project, idx) => (
                                    <li key={idx} className="mb-4 text-dark">
                                        <div className="fw-bold fs-5 mb-1 d-flex">
                                            <span className="me-2 text-dark fs-4 lh-1">•</span>
                                            <div>
                                                <span>{project.name}</span>
                                                <span className="text-secondary fw-normal fs-6 d-block d-md-inline ms-0 ms-md-2">— {project.subtitle}</span>
                                            </div>
                                        </div>
                                        <p className="ms-4 mt-1 mb-0 fs-6">{project.description}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default Experience;